export class Supplier {
  id?: number;
  code: string;
  entity_id: number;
  entity_name?: string;

}

export class SupplierBrand {
  id? : number;
  supplier_id: number;
  brand_id: number;
  brand_name: string;
}

export class SupplierCertification {
  id? : number;
  supplier_id: number;
  certification_id: number;
  certification_name: string;
}



// WEBPACK FOOTER //
// ./src/app/models/supplier.model.ts